import React from "react";
import { useParams } from "react-router-dom";
import ProductDetailsOne from "../components/ProductDetailsOne";
import NewArrivalTwo from "../components/NewArrivalTwo";
import BreadcrumbTwo from "../components/BreadcrumbTwo";
import ProductReviews from "../components/ProductReviews";

const ProductDetailsPageOne = () => {
  const { id } = useParams();

  return (
    <>
      <BreadcrumbTwo title="Product Details" />

      <ProductDetailsOne />
      <ProductReviews />

      <NewArrivalTwo currentProductId={id} />
    </>
  );
};

export default ProductDetailsPageOne;